"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMediaQueriesKeys;

function createMediaQueriesKeys(breakPoints) {
  return breakPoints.map(function (bp) {
    return "@media screen and (min-width: ".concat(bp, "px)");
  });
}